// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.curved-border {
    border-bottom: 0.5px solid transparent;
    border-image-source: linear-gradient(270deg, rgba(0, 0, 0, 0) 1.8%, #FFFFFF4F 40.15%, rgba(255, 255, 255, 0) 100.78%);
    border-image-slice: 1;
    border-image-width: 0 0 0.5px 0;
    border-image-outset: 0;
    border-image-repeat: stretch;
}

.curved-border2 {
    border-image-source: linear-gradient(270deg, rgba(0, 0, 0, 0) 1.8%, #ffffff 40.15%, rgba(255, 255, 255, 0) 100.78%);
    border-image-slice: 1;
}

@keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  .marquee-container {
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    width: 100vw; /* Set the width of the container */
  }
  
  .marquee-content {
    overflow: hidden;
    white-space: nowrap;
    width: fit-content;
    animation: marquee 7s infinite linear; /* Adjust the duration (5s in this example) */
  }


  html.lenis {
    height: auto;
  }
  
  .lenis.lenis-smooth {
    scroll-behavior: auto;
  }
  
  .lenis.lenis-smooth [data-lenis-prevent] {
    overscroll-behavior: contain;
  }
  
  .lenis.lenis-stopped {
    overflow: hidden;
  }
  
  .lenis.lenis-scrolling iframe {
    pointer-events: none;
  }


  .expanding-loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .expanding-loader {
    width: 12px;
    height: 12px;
    background-color: white;
    border-radius: 50%;
    animation: expand 1.5s ease-in-out infinite;
  }
  
  @keyframes expand {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.8);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(52, 152, 219, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/landing/landing.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,qHAAqH;IACrH,qBAAqB;IACrB,+BAA+B;IAC/B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,mHAAmH;IACnH,qBAAqB;AACzB;;AAEA;IACI;MACE,yBAAyB;IAC3B;IACA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY,EAAE,mCAAmC;EACnD;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC,EAAE,6CAA6C;EACtF;;;EAGA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE;MACE,4CAA4C;IAC9C;IACA;MACE,4CAA4C;IAC9C;IACA;MACE,yCAAyC;IAC3C;EACF","sourcesContent":[".curved-border {\n    border-bottom: 0.5px solid transparent;\n    border-image-source: linear-gradient(270deg, rgba(0, 0, 0, 0) 1.8%, #FFFFFF4F 40.15%, rgba(255, 255, 255, 0) 100.78%);\n    border-image-slice: 1;\n    border-image-width: 0 0 0.5px 0;\n    border-image-outset: 0;\n    border-image-repeat: stretch;\n}\n\n.curved-border2 {\n    border-image-source: linear-gradient(270deg, rgba(0, 0, 0, 0) 1.8%, #ffffff 40.15%, rgba(255, 255, 255, 0) 100.78%);\n    border-image-slice: 1;\n}\n\n@keyframes marquee {\n    0% {\n      transform: translateX(0%);\n    }\n    100% {\n      transform: translateX(-50%);\n    }\n  }\n  \n  .marquee-container {\n    white-space: nowrap;\n    overflow: hidden;\n    position: relative;\n    width: 100vw; /* Set the width of the container */\n  }\n  \n  .marquee-content {\n    overflow: hidden;\n    white-space: nowrap;\n    width: fit-content;\n    animation: marquee 7s infinite linear; /* Adjust the duration (5s in this example) */\n  }\n\n\n  html.lenis {\n    height: auto;\n  }\n  \n  .lenis.lenis-smooth {\n    scroll-behavior: auto;\n  }\n  \n  .lenis.lenis-smooth [data-lenis-prevent] {\n    overscroll-behavior: contain;\n  }\n  \n  .lenis.lenis-stopped {\n    overflow: hidden;\n  }\n  \n  .lenis.lenis-scrolling iframe {\n    pointer-events: none;\n  }\n\n\n  .expanding-loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .expanding-loader {\n    width: 12px;\n    height: 12px;\n    background-color: white;\n    border-radius: 50%;\n    animation: expand 1.5s ease-in-out infinite;\n  }\n  \n  @keyframes expand {\n    0% {\n      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.8);\n    }\n    50% {\n      box-shadow: 0 0 0 10px rgba(52, 152, 219, 0);\n    }\n    100% {\n      box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
